import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDocker = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-docker';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.24 6.24v2H3.234l.017 2.87c.017 3.038.021 3.112.223 4.032.68 3.096 3.004 5.207 6.146 5.58.46.054 1.521.024 2.18-.063 1.729-.229 3.206-.829 4.588-1.865.471-.353 1.333-1.204 1.695-1.674.752-.973 1.258-1.963 1.507-2.945l.105-.415H22v-1.52h-2.24V10h-1.52v2.24h-1.48v-8H7.24zm4 .76v1.24H8.76V5.76h2.48zm4 0v1.24h-2.48V5.76h2.48zm-8 4v1.24H4.76V9.76h2.48zm4 0v1.24H8.76V9.76h2.48zm4 0v1.24h-2.48V9.76h2.48zm2.854 2.97c-.312 1.062-1.113 2.293-2.04 3.136a8 8 0 0 1-4.094 2.014c-.719.126-1.956.156-2.525.061-2.028-.337-3.655-1.715-4.295-3.635a7.5 7.5 0 0 1-.325-1.497l-.026-.289h13.367z"
    })
  }));
});
export default SvgDocker;